import useRouter from '@hooks/useRouter';
import { useEffect } from 'react';
import { useLocation } from 'react-router';


export default function ScrollToTop() {
  const { pathname } = useLocation();
  const router = useRouter();
  const state = router.location.state as { cancelScroll: boolean };

  useEffect(() => {
    if (!state?.cancelScroll) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
